// Canonical public origin for auth-email redirects.
//
// Why: magic-link / invite emails carry a redirect_to minted from
// window.location.origin. When the operator runs this app from the Vite dev
// server, that origin is http://localhost:5173 — which is allowlisted (for
// dev), so Supabase honours it and the emailed link strands the recipient on
// a dev server that isn't running (John's 2026-07-26 field report: blank
// localhost:5173). Rule: never mint an auth redirect from a localhost origin.
export const CANONICAL_ORIGIN = 'https://provider-onboarding-web.pages.dev';

export function publicRedirect(): string {
  const { origin, hostname } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  return origin.startsWith('https') && !isLocal ? `${origin}/` : `${CANONICAL_ORIGIN}/`;
}
